// /**
//  * Dashboard1 Page Component
//  * Duplicate of frontpage.js layout and behavior
//  */

// import React, { useEffect, useRef, useState } from 'react';

// const Dashboard1 = () => {
//   const totalSlides = 3;
//   const [activeIndex, setActiveIndex] = useState(0);
//   const autoIntervalRef = useRef(null);
//   const touchStartXRef = useRef(0);
//   const activeIndexRef = useRef(0);
//   const carouselRef = useRef(null);

//   useEffect(() => {
//     document.title = '🎮 WIKIGAME · arcade hub';
//   }, []);

//   useEffect(() => {
//     activeIndexRef.current = activeIndex;
//   }, [activeIndex]);

//   const startAutoPlay = () => {
//     if (autoIntervalRef.current) {
//       window.clearInterval(autoIntervalRef.current);
//     }
//     autoIntervalRef.current = window.setInterval(() => {
//       setActiveIndex((prev) => (prev + 1) % totalSlides);
//     }, 4800);
//   };

//   const stopAutoPlay = () => {
//     if (autoIntervalRef.current) {
//       window.clearInterval(autoIntervalRef.current);
//     }
//   };

//   const updateSlide = (index) => {
//     let nextIndex = index;
//     if (nextIndex < 0) nextIndex = 0;
//     if (nextIndex >= totalSlides) nextIndex = totalSlides - 1;
//     setActiveIndex(nextIndex);
//   };

//   useEffect(() => {
//     startAutoPlay();

//     const carousel = carouselRef.current;
//     if (!carousel) {
//       return () => {
//         stopAutoPlay();
//       };
//     }

//     const handleMouseEnter = () => stopAutoPlay();
//     const handleMouseLeave = () => startAutoPlay();
//     const handleTouchStart = (event) => {
//       touchStartXRef.current = event.changedTouches[0].screenX;
//       stopAutoPlay();
//     };
//     const handleTouchEnd = (event) => {
//       const diff = event.changedTouches[0].screenX - touchStartXRef.current;
//       if (Math.abs(diff) > 50) {
//         if (diff > 0 && activeIndexRef.current > 0) {
//           updateSlide(activeIndexRef.current - 1);
//         } else if (diff < 0 && activeIndexRef.current < totalSlides - 1) {
//           updateSlide(activeIndexRef.current + 1);
//         }
//       }
//       startAutoPlay();
//     };

//     carousel.addEventListener('mouseenter', handleMouseEnter);
//     carousel.addEventListener('mouseleave', handleMouseLeave);
//     carousel.addEventListener('touchstart', handleTouchStart, { passive: true });
//     carousel.addEventListener('touchend', handleTouchEnd);

//     return () => {
//       stopAutoPlay();
//       carousel.removeEventListener('mouseenter', handleMouseEnter);
//       carousel.removeEventListener('mouseleave', handleMouseLeave);
//       carousel.removeEventListener('touchstart', handleTouchStart);
//       carousel.removeEventListener('touchend', handleTouchEnd);
//     };
//   }, []);

//   const handleDotClick = (index) => {
//     updateSlide(index);
//     startAutoPlay();
//   };

//   const handleCardClick = (game) => {
//     window.alert(`✨ Launching ${game} (integrate your game logic here)`);
//   };

//   const handleCardKeyDown = (event, game) => {
//     if (event.key === 'Enter' || event.key === ' ') {
//       event.preventDefault();
//       handleCardClick(game);
//     }
//   };

//   return (
//     <>
//       <link rel="preconnect" href="https://fonts.googleapis.com" />
//       <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
//       <link
//         href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,400;14..32,500;14..32,600;14..32,700&display=swap"
//         rel="stylesheet"
//       />
//       <link
//         rel="stylesheet"
//         href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
//       />

//       <style>{`
//         * {
//             margin: 0;
//             padding: 0;
//             box-sizing: border-box;
//             font-family: 'Inter', sans-serif;
//         }

//         body {
//             background: linear-gradient(145deg, #0c0f1c 0%, #1a1f33 100%);
//             min-height: 100vh;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             padding: 16px;
//         }

//         /* main glossy card container */
//         .arcade-dashboard {
//             max-width: 1280px;
//             width: 100%;
//             background: rgba(18, 22, 40, 0.65);
//             backdrop-filter: blur(18px) saturate(180%);
//             -webkit-backdrop-filter: blur(18px) saturate(180%);
//             border-radius: 56px;
//             border: 1px solid rgba(255, 255, 255, 0.08);
//             box-shadow: 0 30px 60px -10px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(255, 255, 255, 0.03) inset;
//             padding: 28px 24px 36px;
//             transition: all 0.3s ease;
//         }

//         /* header with slideshow banner */
//         .banner-carousel {
//             width: 100%;
//             border-radius: 32px;
//             overflow: hidden;
//             margin-bottom: 40px;
//             position: relative;
//             background: #05070c;
//             box-shadow: 0 18px 30px -12px #00000080, 0 0 0 1px rgba(255, 255, 255, 0.05) inset;
//           padding-bottom: 28px;
//         }

//         .slide-container {
//             display: flex;
//             transition: transform 0.7s cubic-bezier(0.23, 1, 0.32, 1);
//             will-change: transform;
//         }

//         .slide {
//             flex: 0 0 100%;
//             display: flex;
//             align-items: center;
//             justify-content: space-between;
//             padding: 28px 32px;
//             background: radial-gradient(circle at 0% 30%, #2a2f55, #12172f);
//             border-bottom: 1px solid rgba(255, 215, 0, 0.2);
//           gap: 16px;
//         }

//         .slide-content {
//             color: white;
//         }

//         .slide-content h2 {
//             font-size: clamp(1.5rem, 5vw, 2.4rem);
//             font-weight: 700;
//             letter-spacing: -0.02em;
//             background: linear-gradient(120deg, #fff, #d6e0ff);
//             -webkit-background-clip: text;
//             -webkit-text-fill-color: transparent;
//             margin-bottom: 8px;
//         }

//         .slide-content p {
//             font-size: 1rem;
//             font-weight: 400;
//             color: #b5c2e0;
//             max-width: 70%;
//         }

//         .slide-badge {
//             background: rgba(255, 255, 255, 0.03);
//             backdrop-filter: blur(6px);
//             border-radius: 60px;
//             padding: 12px 28px;
//             font-weight: 600;
//             font-size: 1.2rem;
//             border: 1px solid rgba(255, 215, 0, 0.3);
//             box-shadow: 0 10px 18px -6px #00000080;
//             color: #ffecbb;
//             white-space: nowrap;
//         }

//         .carousel-dots {
//             position: absolute;
//             bottom: 18px;
//             left: 50%;
//             transform: translateX(-50%);
//             display: flex;
//             gap: 12px;
//             z-index: 5;
//         }

//         .dot {
//             width: 10px;
//             height: 10px;
//             border-radius: 10px;
//             background: rgba(255,255,255,0.25);
//             border: 1px solid rgba(255,255,255,0.1);
//             transition: all 0.3s ease;
//             cursor: pointer;
//         }

//         .dot.active {
//             width: 30px;
//             background: #ffd966;
//             border-color: #ffb347;
//             box-shadow: 0 0 10px #ffb347;
//         }

//         /* main menu title */
//         .section-label {
//             display: flex;
//             align-items: center;
//             gap: 12px;
//             margin-bottom: 22px;
//         }

//         .section-label span {
//             font-size: 1.5rem;
//             font-weight: 600;
//             color: white;
//             letter-spacing: -0.02em;
//             background: rgba(255,255,255,0.02);
//             padding: 8px 24px 8px 18px;
//             border-radius: 40px;
//             border: 1px solid rgba(255,255,255,0.05);
//             backdrop-filter: blur(4px);
//         }

//         .section-label i {
//             color: #f2c94c;
//             text-shadow: 0 0 8px #f2c94c;
//         }

//         /* GAME GRID – modern card layout */
//         .game-grid {
//             display: grid;
//             grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
//             gap: 20px;
//         }

//         /* game card – sleek glassmorphism + animation */
//         .game-card {
//             background: rgba(20, 25, 45, 0.6);
//             backdrop-filter: blur(12px);
//             -webkit-backdrop-filter: blur(12px);
//             border: 1px solid rgba(255, 255, 255, 0.04);
//             border-radius: 34px;
//             padding: 24px 12px 20px;
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             text-align: center;
//             transition: all 0.35s cubic-bezier(0.2, 0.9, 0.3, 1.2);
//             box-shadow: 0 16px 24px -12px rgba(0, 0, 0, 0.6);
//             cursor: pointer;
//             position: relative;
//             will-change: transform, background, border-color;
//         }

//         /* glowing border on hover / focus */
//         .game-card:hover, .game-card:focus-visible {
//             transform: translateY(-10px) scale(1.02);
//             background: rgba(30, 38, 70, 0.8);
//             border-color: rgba(255, 215, 0, 0.4);
//             box-shadow: 0 30px 30px -12px #000000cc, 0 0 0 2px rgba(255, 200, 50, 0.2) inset;
//             outline: none;
//         }

//         /* active / focused state for mobile & keyboard */
//         .game-card:active {
//             transform: scale(0.98);
//             background: rgba(40, 48, 85, 0.9);
//         }

//         .card-icon {
//             font-size: 3.3rem;
//             margin-bottom: 16px;
//             filter: drop-shadow(0 8px 12px #00000060);
//             transition: 0.2s;
//         }

//         .game-card:hover .card-icon {
//             transform: rotate(3deg) scale(1.05);
//         }

//         .game-title {
//             font-weight: 700;
//             font-size: 1.4rem;
//             background: linear-gradient(180deg, #ffffff 0%, #cfd9ff 100%);
//             -webkit-background-clip: text;
//             -webkit-text-fill-color: transparent;
//             letter-spacing: -0.01em;
//             margin-bottom: 6px;
//         }

//         .game-desc {
//             font-size: 0.8rem;
//             font-weight: 400;
//             color: #9aa8d0;
//             margin-bottom: 20px;
//             padding: 0 8px;
//         }

//         .play-badge {
//             background: rgba(255,255,255,0.03);
//             border: 1px solid rgba(255,215,0,0.2);
//             border-radius: 60px;
//             padding: 8px 20px;
//             font-size: 0.8rem;
//             font-weight: 600;
//             color: #ffecbb;
//             letter-spacing: 0.5px;
//             transition: 0.25s;
//             margin-top: auto;
//             backdrop-filter: blur(4px);
//         }

//         .game-card:hover .play-badge {
//             background: rgba(255, 215, 0, 0.15);
//             border-color: #f2c94c;
//             color: #fff6d9;
//             box-shadow: 0 0 16px #f2c94c30;
//         }

//         /* individual game icon colors */
//         .game-card[data-game="chess"] .card-icon { color: #c2a477; text-shadow: 0 0 15px #c2a477; }
//         .game-card[data-game="whot"] .card-icon { color: #fa5f5f; text-shadow: 0 0 15px #fa5f5f; }
//         .game-card[data-game="flappy"] .card-icon { color: #4dd0e1; text-shadow: 0 0 15px #4dd0e1; }
//         .game-card[data-game="color"] .card-icon {
//             background: linear-gradient(135deg, #ff7eb3, #ffd93d, #6bcb77, #4d96ff);
//             -webkit-background-clip: text;
//             -webkit-text-fill-color: transparent;
//             background-clip: text;
//         }
//         .game-card[data-game="dice"] .card-icon { color: #ffb649; text-shadow: 0 0 15px #ffb649; }

//         /* mobile fine-tune */
//         @media (max-width: 600px) {
//           body { align-items: flex-start; }
//           .arcade-dashboard { border-radius: 32px; padding: 16px 12px 20px; }
//           .banner-carousel { margin-bottom: 24px; }
//           .slide {
//             padding: 14px 16px;
//             flex-direction: column;
//             align-items: flex-start;
//             gap: 12px;
//           }
//           .slide-content h2 { font-size: clamp(1.2rem, 6vw, 1.8rem); }
//           .slide-content p {
//             max-width: 100%;
//             font-size: 0.9rem;
//             line-height: 1.25;
//           }
//           .slide-badge { padding: 6px 12px; font-size: 0.85rem; }
//           .game-grid { gap: 14px; grid-template-columns: 1fr; }
//             .game-card { border-radius: 26px; padding: 18px 6px 14px; }
//             .card-icon { font-size: 2.5rem; }
//             .game-title { font-size: 1.2rem; }
//         }

//         @media (max-width: 380px) {
//           .game-grid { grid-template-columns: 1fr; }
//         }

//         /* decorative micro-interactions */
//         .glow {
//             position: absolute;
//             width: 100%;
//             height: 100%;
//             background: radial-gradient(circle at 50% 0%, rgba(255,240,160,0.1), transparent 70%);
//             opacity: 0;
//             transition: opacity 0.5s;
//             pointer-events: none;
//             border-radius: 34px;
//         }
//         .game-card:hover .glow { opacity: 0.6; }

//         /* smooth entrance animation */
//         @keyframes float-in {
//             0% { opacity: 0; transform: translateY(20px); }
//             100% { opacity: 1; transform: translateY(0px); }
//         }
//         .game-card {
//             animation: float-in 0.6s ease backwards;
//         }
//         .game-card:nth-child(1) { animation-delay: 0.05s; }
//         .game-card:nth-child(2) { animation-delay: 0.1s; }
//         .game-card:nth-child(3) { animation-delay: 0.15s; }
//         .game-card:nth-child(4) { animation-delay: 0.2s; }
//         .game-card:nth-child(5) { animation-delay: 0.25s; }
//       `}</style>

//       <div className="arcade-dashboard">
//         <div className="banner-carousel" id="bannerCarousel" ref={carouselRef}>
//           <div
//             className="slide-container"
//             id="slideContainer"
//             style={{ transform: `translateX(-${activeIndex * 100}%)` }}
//           >
//             <div className="slide">
//               <div className="slide-content">
//                 <h2>♜  CLASSIC CHESS</h2>
//                 <p>Deep strategy, sleek design. Challenge friends or AI.</p>
//               </div>
//               <div className="slide-badge">
//                 <i className="fas fa-chess-queen" style={{ marginRight: '8px' }}></i> grandmaster
//               </div>
//             </div>
//             <div className="slide">
//               <div className="slide-content">
//                 <h2>🎲  WHOT & DICE</h2>
//                 <p>Fast card game + dice rolls. Surprise every round!</p>
//               </div>
//               <div className="slide-badge">
//                 <i className="fas fa-crown" style={{ marginRight: '8px' }}></i> family
//               </div>
//             </div>
//             <div className="slide">
//               <div className="slide-content">
//                 <h2>🌈  COLOR CONFUSION</h2>
//                 <p>Test your brain with tricky colors & flappy bird arcade.</p>
//               </div>
//               <div className="slide-badge">
//                 <i className="fas fa-dragon" style={{ marginRight: '8px' }}></i> action
//               </div>
//             </div>
//           </div>
//           <div className="carousel-dots" id="carouselDots">
//             {[0, 1, 2].map((index) => (
//               <div
//                 key={`dot-${index}`}
//                 className={`dot ${index === activeIndex ? 'active' : ''}`}
//                 data-index={index}
//                 onClick={() => handleDotClick(index)}
//               />
//             ))}
//           </div>
//         </div>

//         <div className="section-label">
//           <span>
//             <i className="fas fa-compass" style={{ marginRight: '10px' }}></i> GAME HUB · five worlds
//           </span>
//         </div>

//         <div className="game-grid">
//           <div
//             className="game-card"
//             data-game="chess"
//             tabIndex={0}
//             role="button"
//             aria-label="Play Chess"
//             onClick={() => handleCardClick('chess')}
//             onKeyDown={(event) => handleCardKeyDown(event, 'chess')}
//           >
//             <div className="glow"></div>
//             <div className="card-icon"><i className="fas fa-chess-knight"></i></div>
//             <div className="game-title">CHESS</div>
//             <div className="game-desc">tactical · 2 player</div>
//             <div className="play-badge">PLAY <i className="fas fa-arrow-right" style={{ marginLeft: '6px', fontSize: '10px' }}></i></div>
//           </div>
//           <div
//             className="game-card"
//             data-game="whot"
//             tabIndex={0}
//             role="button"
//             aria-label="Play Whot"
//             onClick={() => handleCardClick('whot')}
//             onKeyDown={(event) => handleCardKeyDown(event, 'whot')}
//           >
//             <div className="glow"></div>
//             <div className="card-icon"><i className="fas fa-layer-group"></i></div>
//             <div className="game-title">WHOT</div>
//             <div className="game-desc">fast · card match</div>
//             <div className="play-badge">PLAY <i className="fas fa-arrow-right" style={{ marginLeft: '6px', fontSize: '10px' }}></i></div>
//           </div>
//           <div
//             className="game-card"
//             data-game="flappy"
//             tabIndex={0}
//             role="button"
//             aria-label="Play Flappy Bird"
//             onClick={() => handleCardClick('flappy')}
//             onKeyDown={(event) => handleCardKeyDown(event, 'flappy')}
//           >
//             <div className="glow"></div>
//             <div className="card-icon"><i className="fas fa-dove"></i></div>
//             <div className="game-title">FLAPPY BIRD</div>
//             <div className="game-desc">reflex · endless</div>
//             <div className="play-badge">PLAY <i className="fas fa-arrow-right" style={{ marginLeft: '6px', fontSize: '10px' }}></i></div>
//           </div>
//           <div
//             className="game-card"
//             data-game="color"
//             tabIndex={0}
//             role="button"
//             aria-label="Play Color Confusion"
//             onClick={() => handleCardClick('color')}
//             onKeyDown={(event) => handleCardKeyDown(event, 'color')}
//           >
//             <div className="glow"></div>
//             <div className="card-icon"><i className="fas fa-palette"></i></div>
//             <div className="game-title">COLOR</div>
//             <div className="game-desc">confusion · mind</div>
//             <div className="play-badge">PLAY <i className="fas fa-arrow-right" style={{ marginLeft: '6px', fontSize: '10px' }}></i></div>
//           </div>
//           <div
//             className="game-card"
//             data-game="dice"
//             tabIndex={0}
//             role="button"
//             aria-label="Play Dice"
//             onClick={() => handleCardClick('dice')}
//             onKeyDown={(event) => handleCardKeyDown(event, 'dice')}
//           >
//             <div className="glow"></div>
//             <div className="card-icon"><i className="fas fa-dice-d20"></i></div>
//             <div className="game-title">DICE</div>
//             <div className="game-desc">luck · classic</div>
//             <div className="play-badge">PLAY <i className="fas fa-arrow-right" style={{ marginLeft: '6px', fontSize: '10px' }}></i></div>
//           </div>
//         </div>

//         <div
//           style={{
//             marginTop: '32px',
//             textAlign: 'right',
//             color: '#4e5980',
//             fontSize: '0.8rem',
//             letterSpacing: '1px',
//             borderTop: '1px dashed #2f3763',
//             paddingTop: '18px',
//           }}
//         >
//           <i className="fas fa-crown" style={{ color: '#ffd966' }}></i> five games · one hub{' '}
//           <i className="fas fa-crown" style={{ color: '#ffd966', marginLeft: '8px' }}></i>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Dashboard1;
